import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { H1, Sub, Skeleton } from "./_shared";

export default function OverviewSection() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setData(r.data)); }, []);
  if (!data) return <Skeleton />;
  const k = (label, value) => (
    <div className="pp-card p-4">
      <div className="text-xs text-zinc-500 uppercase tracking-wider">{label}</div>
      <div className="font-heading text-2xl font-bold mt-1 text-[#00E676]">{value}</div>
    </div>
  );
  return (
    <div data-testid="cp-overview">
      <H1>Overview</H1>
      <Sub>Platform health at a glance.</Sub>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-6">
        {k("Total users", data.users.total)}
        {k("Suspended", data.users.suspended)}
        {k("Clubs (verified)", `${data.clubs.verified}/${data.clubs.total}`)}
        {k("Open matches", data.events.matches_open)}
        {k("Tournaments", data.events.tournaments)}
        {k("Leagues", data.events.leagues)}
        {k("Lessons", data.events.lessons)}
        {k("Revenue (paid)", `${data.billing.payments_total || 0} EUR`)}
        {k("Invoices paid", data.billing.invoices_paid)}
        {k("Invoices pending", data.billing.invoices_pending)}
        {k("Refunded", data.billing.payments_refunded)}
      </div>
      <div className="mt-8 pp-card p-6">
        <h3 className="font-heading text-xl font-bold mb-3">Users by role</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {Object.entries(data.users.by_role).map(([role, n]) => (
            <div key={role} className="pp-card p-3 flex items-center justify-between">
              <span className="capitalize">{role.replace("_", " ")}</span>
              <span className="text-[#00E676] font-bold">{n}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
